export const LOAD_TICKETS = 'LOAD_TICKETS';
